import { Injectable } from '@angular/core'
import { FormArray, FormGroup } from '@angular/forms'

@Injectable({
  providedIn: 'root',
})
export class FormValidator {
  validate(formGroup: FormGroup): boolean {
    if (formGroup.invalid) {
      this.logInvalidControls(formGroup)
      formGroup.markAllAsTouched()
      this.scrollToTop()
      return false
    } else {
      return true
    }
  }

  private logInvalidControls(formGroup: FormGroup | FormArray, path: string = ''): void {
    Object.keys(formGroup.controls).forEach((key) => {
      const control = formGroup.get(key)

      const fullPath = path ? `${path}.${key}` : key

      if (control instanceof FormGroup || control instanceof FormArray) {
        this.logInvalidControls(control, fullPath)
      }
    })
  }

  public scrollToTop(duration: number = 500): void {
    const start = window.scrollY
    const change = 0 - start
    const startTime = performance.now()

    const animateScroll = (currentTime: number): void => {
      const elapsed = currentTime - startTime
      const progress = Math.min(elapsed / duration, 1)

      window.scrollTo(0, start + change * this.easeInOut(progress))

      if (progress < 1) {
        requestAnimationFrame(animateScroll)
      }
    }

    requestAnimationFrame(animateScroll)
  }

  private easeInOut(t: number): number {
    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t
  }
}
